import React from "react";
import Logo from "../images/LogoBig.png";
import logotxt from "../images/logotxt.png";
import Wave from "react-wavify";

const guidelinesData = {
  "guidelines": [
    {
      "category": "USER GUIDELINES FOR INDUSTRIAL WASTE IN NEARBY WATER BODY",
      "steps": [
        "Report Immediately to Jal-Suraksha: Report industrial waste discharge to Jal-Suraksha.",
        "Do Not Approach the Site: Avoid direct contact with contaminated water.",
        "Evacuate if Necessary: Follow evacuation instructions if there is an immediate threat.",
        "Protect Yourself: Wash exposed skin if you come into contact with contaminated water.",
        "Keep Children and Pets Away: Ensure that children and pets are kept away from the affected water body.",
        "Document the Incident: Take photographs or videos from a safe distance.",
        "Collect Witness Statements: Collect statements from witnesses if available.",
        "Contact Environmental Agencies: Reach out to environmental protection agencies.",
        "Follow Local News and Updates: Stay informed about the situation through local news.",
        "Participate in Community Advocacy: Engage with local community groups and environmental organizations.",
        "Demand Accountability: Demand accountability from responsible industries and local authorities.",
        "Support Legal Actions: Support legal actions taken against industries responsible for contamination.",
        "Promote Sustainable Practices: Advocate for sustainable industrial practices.",
        "Monitor Water Quality: Stay vigilant about water quality in your locality.",
        "Educate the Community: Educate your community about the risks associated with industrial waste."
      ]
    }
  ]
};

const FixedBottomAnimation = () => (
  <div className="absolute bottom-0 left-0 right-0">
    <Wave
      mask="url(#mask)"
      fill="#49B5F0"
      options={{
        height: 10,
        amplitude: 24,
        speed: 0.3,
        points: 3,
      }}
    >
      <defs>
        <linearGradient id="gradient" gradientTransform="rotate(90)">
          <stop offset="0" stopColor="white" />
          <stop offset="0.5" stopColor="black" />
        </linearGradient>
      </defs>
    </Wave>
  </div>
);

const WasteIndustrial = () => {
  return (
    <div className="relative bg-white overflow-y-auto pb-20">
      <div className="w-full text-center">
        <div className="mb-2 mx-auto md:w-[7.5%] md:h-[7.5%] w-[15%] h-[15%] mt-0">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/b/b1/Ministry_of_Jal_Shakti.svg"
            alt=""
          />
        </div>
        <div className="mb-2 mx-auto md:w-[2%] w-[4%] mt-0">
          <img
            src={Logo}
            alt=""
            className="w-full mx-auto my-auto"
          />
        </div>
        <div className="mb-2 mx-auto md:w-[10%] w-[20%] mt-2">
          <img
            src={logotxt}
            alt=""
            className="w-full mx-auto my-auto"
          />
        </div>
        <div className="p-6 bg-white text-black rounded border border-gray-800">
          <h1 className="text-3xl font-bold mb-4 text-center border-b border-black pt-2">{guidelinesData.guidelines[0].category}</h1>
          <div className="text-left text-xl">
            <ul className="list-disc list-inside">
              {guidelinesData.guidelines[0].steps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ul>
          </div>
          <div className="p-10"></div>
        </div>
      </div>
      <FixedBottomAnimation />
    </div>
  );
};

export default WasteIndustrial;
